import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import css from './IntegrationTableCells.css';
import StatusBadge from './StatusBadge';

const EmptyValue = () => <Icon name="minus" size={IconSizes.SMALL} variant={IconVariants.LIGHT} interactive={false} />;

export const StatusCell = ({ row }) => (
    <td>
        <StatusBadge status={row.status} />
    </td>
);

export const DateCell = ({ value }) => <td className={css.date}>{value || <EmptyValue />}</td>;

export const ActionsCell = ({ value }) => <td className={css.actionsCell}>{value}</td>;

export const TextCell = ({ value }) => <td className={css.textCell}>{value || <EmptyValue />}</td>;

StatusCell.propTypes = {
    row: PropTypes.shape({
        status: PropTypes.string.isRequired,
    }).isRequired,
};

DateCell.propTypes = {
    value: PropTypes.string.isRequired,
};

ActionsCell.propTypes = {
    value: PropTypes.node,
};

TextCell.propTypes = {
    value: PropTypes.string,
};
